import React, { useState } from 'react';
import { FilePicker } from 'react-file-picker';
import { uploadFile } from 'services/api/common';
import { isDeviceMobile, showError, showSuccess } from 'utils';
import ActionButton from '../ActionButton';
import styles from './index.module.scss';
import WebcamImagePickerModal from 'components/WebcamImagePicker';

const WebCamModalContainer = (props) => {
  const [webcamModalOpen, setWebCamModalOpen] = React.useState<boolean>(false);

  const submitImage = (src) => {
    setWebCamModalOpen(!webcamModalOpen);
    props.onChange(src);
  };

  const submitFile = (file) => {
    setWebCamModalOpen(!webcamModalOpen);
    props.onChange(file);
  };

  return (
    <div className={styles['webcam-container']}>
      <i
        className={'fa fa-camera'}
        onClick={() => setWebCamModalOpen(!webcamModalOpen)}
      />
      {webcamModalOpen && (
        <WebcamImagePickerModal
          toggleModal={() => setWebCamModalOpen(!webcamModalOpen)}
          submitFile={submitFile}
        />
      )}
    </div>
  );
};

const FileUploadComponent = props => {
  const [file, setFile] = useState<any>();
  const [fileType, setFileType] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [showUploadButton, setShowUploadButton] = useState<boolean>(false);
  const { entityId, uploadAPI } = props;

  const uploadDocument = async () => {
    setLoading(true);
    try {
      const _file = await uploadFile(file);
      await uploadAPI(entityId, _file);
      setShowUploadButton(false);
      showSuccess('File uploaded successfully.');
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };
  
  const onChange = async (file) => {
    setFileType(file.type === 'application/pdf' ? 'application/pdf' : 'image/jpg');
    try {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setFile(reader.result);
        setShowUploadButton(true);
      };
    } catch (e) {
      console.log(e);
    }
  };

  return  (
    <div>
      {file ? (
        <>
          {fileType === 'application/pdf' ? (
            <object data={file} type={fileType} width={'200px'} height={'162px'} />
          ): (
            <img
              className="uploaded-image"
              src={file?.toString()} alt={'Item image'}
              width={'200px'}
              height={'162px'}
            />
          )}
        </>
      ) : (
        <div className={styles['no-file-message']}>Select File</div>
      )}
      <FilePicker
        extensions={['jpg', 'jpeg', 'png', 'pdf']}
        onChange={onChange}
        onError={showError}
        maxSize={10}
      >
        <i className={'fa fa-pencil'} />
      </FilePicker>
      {(props.showWebcamImagePicker && !isDeviceMobile()) && (
        <WebCamModalContainer onChange={onChange} />
      )}
      {showUploadButton && (
        <ActionButton
          active={!loading}
          onClick={uploadDocument}
          isLoading={loading}
          text={'Upload'}
        />
      )}
    </div>
  );
};

export default FileUploadComponent;